import React from 'react';
import { v1 as uuid } from 'uuid';
import PropTypes from 'prop-types';
import {
  StyledFooter,
  StyledFooterBox,
  StyledFooterButton,
  FooterLabel,
  StyledLabelMore
} from './Styles';

const propTypes = {
  label: PropTypes.string,
  secondaryLabel: PropTypes.string,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      onClick: PropTypes.func,
      dataTestId: PropTypes.string
    })
  ),
  showFooterLabel: PropTypes.bool
};

const defaultProps = {
  label: '',
  secondaryLabel: '',
  buttons: [],
  showFooterLabel: true
};

const ListPageFooter = ({
  label,
  secondaryLabel,
  buttons,
  showFooterLabel,
  className
}) => {
  return (
    <StyledFooter data-testid="pageFooter" className={className}>
      {showFooterLabel && (
        <FooterLabel data-testid="pageFooterLabel">{label}</FooterLabel>
      )}
      {secondaryLabel && (
        <StyledLabelMore testId="pageFooterLabelMore">
          {secondaryLabel}
        </StyledLabelMore>
      )}
      <StyledFooterBox>
        {buttons.map(button => {
          return (
            <StyledFooterButton
              data-testid={button.dataTestId}
              key={uuid()}
              onClick={button.onClick}
            >
              {button.text}
            </StyledFooterButton>
          );
        })}
      </StyledFooterBox>
    </StyledFooter>
  );
};

ListPageFooter.propTypes = propTypes;
ListPageFooter.defaultProps = defaultProps;

export default ListPageFooter;
